import {useEffect, useRef} from 'react';
import {PaymentFormSkeleton} from './PaymentFormSkeleton';

type Props = {
  isLoading?: boolean;
};

export const ProviderForm = ({isLoading = false}: Props) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    if (iframeRef.current) {
      iframeRef.current.setAttribute('allow', 'payment *');
    }
  }, []);

  return (
    <>
      {isLoading && <PaymentFormSkeleton />}
      {/*{isLoading && (*/}
      {/*  <div className="absolute inset-0 flex items-center justify-center bg-white z-10">*/}
      {/*    <MainLoader visible width={80} />*/}
      {/*  </div>*/}
      {/*)}*/}
      <iframe
        ref={iframeRef}
        id="global-payment-iframe"
        title="Global Payments"
        allow="payment *"
        className="w-full h-[562px] border-none"
      />
    </>
  );
};
